export function rewriteUrlNew(queryParam, newValue, pushState = false) {
    const baseUrl = window.location.origin + window.location.pathname;

    if (!('URLSearchParams' in window)) {
        throw new Error('URLSearchParams not supported by browser.');
    }

    let searchParams = new URLSearchParams(window.location.search);
    // For objects and arrays, JSON-stringify them.
    let paramValue = typeof newValue === 'object' ? JSON.stringify(newValue) : newValue;

    // If the value is empty, remove the query parameter.
    if (
        paramValue === undefined ||
        paramValue === null ||
        paramValue === '' ||
        paramValue === '{}' ||
        paramValue === '[]'
    ) {
        searchParams.delete(queryParam);
    } else {
        searchParams.set(queryParam, paramValue);
    }

    const queryString = searchParams.toString();
    const newUrl = queryString ? `${baseUrl}?${queryString}` : baseUrl;

    // Update the browsers URL without reloading the page.
    if (pushState) {
        window.history.pushState(null, '', newUrl);
    } else {
        window.history.replaceState(null, '', newUrl);
    }

    return newUrl;
}

export function getQueryParameter(parameterName, defaultValue = null) {
    let parameters = new URL(document.location.toString()).searchParams;
    let parameter = parameters.get(parameterName);

    if (parameter === null || parameter.trim().length === 0) {
        return defaultValue;
    }

    return parameter.trim();
}
